/**IMPORTANT LIBRARY IMPORT */
import React from "react";

/**COMPONENTS IMPORT */
import PageHero from "../Components/PageHero";


const CaseStudyDetail=()=>{
 

    return(
        <>
       
        {/**HERO SECTION */}
        <PageHero heading={"Growth Strategy for Retail Brand"}/>

        </>
    )
}

export default CaseStudyDetail;